// Mui
import { Pagination } from '@mui/material';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
// self component data and hooks
import { defaultStyles, defaultSizes, defaultOptions } from './data';
import { useDataPaginate } from './useDataPaginate'
import './CustomPaginate.scss'

const CustomPaginate = ({
  listLength,
  updateFromPaginator,
  paginateMessageGenerator,
  selectLabel,
  sizes = defaultSizes, // object that contains data sizes for grid
  customStyles = defaultStyles, 
  optionsRecordsPerPage = defaultOptions, // number of records per page
  margins = {x: '0', y: '0'},
}) => {
  const { fisrtStyles, secondStyles, thirdStyles, autocompleteStyles } = customStyles;
  const {
    recordsPerPage,
    currentPage,
    numberPages,
    paginateMessage,
    changePage,
    changeRecords,
  } = useDataPaginate(listLength, optionsRecordsPerPage[0], 1, updateFromPaginator, paginateMessageGenerator);

  const handleChangeRecordsPerPage = (event, newSize) => {
    changeRecords(newSize);
  }

  const handleChangePage = (event, newPage) => {
    changePage(newPage);
  };

  return (
    <div className="custom-paginate" style={{ margin: `${margins.y} ${margins.x}` }}>
      <Grid container spacing={2}>
        <Grid
          size={sizes[0]}
          sx={fisrtStyles}
        >
          <Autocomplete
            value={recordsPerPage}
            onChange={handleChangeRecordsPerPage}
            id="controllable-states-demo"
            options={optionsRecordsPerPage}
            getOptionLabel={(option) => `${option}`}
            sx={autocompleteStyles}
            renderInput={(params) => <TextField {...params} label={selectLabel} />}
          />
        </Grid>
        <Grid
          size={sizes[1]}
          sx={secondStyles}
        >
          <Pagination
            page={currentPage}
            onChange={handleChangePage}
            count={numberPages}
            className='custom-pagination'
            variant="outlined"
            shape="rounded"
          />
        </Grid>
        <Grid
          size={sizes[2]}
          sx={thirdStyles}
        >
          <div>{paginateMessage}</div>
        </Grid>
      </Grid>
    </div>
  );
};

export default CustomPaginate;